import { executeRequest, Request } from '@jfs/network'
import { AgentInfo } from '../../data/models/Agent'
import { RootStore } from '../../data/store'
import {
  calculateGrossAmount,
  generateRandomNumber,
  generateRandomString,
  getCompleteDate,
  getNetworkResponseError,
  isStatusOK,
  RSAEncrypt,
  TRANSACTION_CONSTANTS,
} from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
import { COUNTRY_CODE } from './LoginReq'

const responseParser = (data: any) => {
  if (isStatusOK(data) && ['00', '01'].includes(data?.data?.responseCode)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const TRANSACTION_CONSTANTS_VB = {
  type: '309',
  subType: '550',
  ZERO: 0,
  TYPE: 13,
  LIVEMODE: 'true',
}

const returnValidateBeneficiaryData = (body: any, agent: typeof AgentInfo.properties) => {
  console.log(RootStore?.customerDetails?.newRemittanceUserId, "checknewremiteerr:::")
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  const GROSS_AMT = calculateGrossAmount(body?.grossAmountOfValidation, [
    body?.charges?.cgst,
    body?.charges?.igst,
    body?.charges?.sgst,
    body?.charges?.ugst,
    body?.charges?.tds,
    body?.charges?.tcs,
  ])
  return {
    transaction: {
      idempotentKey: generateRandomNumber(16),
      currency: TRANSACTION_CONSTANTS.currency, //Hard coded
      invoice: generateRandomNumber(16),
      method: {
        type: TRANSACTION_CONSTANTS_VB.type,
        subType: TRANSACTION_CONSTANTS_VB.subType,
      },
      mode: TRANSACTION_CONSTANTS.mode,
      metadata: {
        agent: {
          address: {
            stateCode: agent.agentUserDealerState,
            pinCode: agent.agentUserDealerPinCode,
          },
          agentUser: {
            id: agent.agentUserLoginId,
          },
          id: '1000000001',
          organization: {
            id: '1',
          },
        },
        terminal: {
          id: null,
        },
      },
      captureMethod: TRANSACTION_CONSTANTS.captureMethod,
      livemode: TRANSACTION_CONSTANTS_VB.LIVEMODE,
      application: RootStore?.agent?.session?.CHANNEL_ID,
      initiatingEntityTimestamp: getCompleteDate(), //Current time stamp with milliseconds.
      initiatingEntity: {
        entityId: RootStore?.agent?.session?.CHANNEL_ID,
        callbackUrl: TRANSACTION_CONSTANTS.callbackUrl,
      },
    },
    amount: {
      netAmount: body?.grossAmountOfValidation, //Hard coded as 0
      grossAmount: GROSS_AMT,
      //2.54 from the value of grossAmount of validate BENE api + all the GST', //(Gross amount = charges value + net amount)
      charges: [
        {
          value: GROSS_AMT, //2.54 from the value of grossAmount of validate BENE api + all the GST', //same as grossAmount
          cgst: body?.charges?.cgst,
          igst: body?.charges?.igst,
          sgst: body?.charges?.sgst,
          ugst: body?.charges?.ugst,
          serviceCharge: TRANSACTION_CONSTANTS_VB.ZERO, // As it is already been calculated in G.A. so we need to make it zero. Confirmed by BE.
          tds: body?.charges?.tds,
          tcs: body?.charges?.tcs,
          type: null,
        },
      ],
    },
    //Payer is Remitter <-> Customer
    payer: {
      userId: body?.remittanceUserId || RootStore?.customerDetails?.newRemittanceUserId, //Remitter id
      mobile: {
        number: body?.mobile, //remitter phone number
        countryCode: COUNTRY_CODE,
      },
      type: TRANSACTION_CONSTANTS_VB.TYPE,
    },
    //Beneficiary Bank details
    payee: {
      accountNumber: body?.beneficiaryAccountNumber, //Beneficiary Bank account
      bankIfsc: body?.ifscCode, //beneficiary ifsc
    },
    secure: {
      encryptionKey: encryptedKey,
      deviceInfo: {
        peripheral: 'biometric device encrypted code',
        source: {
          type: 'MOB',
          id: RootStore?.agent?.deviceInfo?.id,
          ip: RootStore?.agent?.deviceInfo?.ip,
          osType: 'ANDROID',
          osVer: RootStore?.agent?.deviceInfo?.osVer,
          model: RootStore?.agent?.deviceInfo?.model,
        },
        location: {
          latitude: RootStore?.agent?.deviceInfo?.latitude,
          longitude: RootStore?.agent?.deviceInfo?.longitude,
        },
      },
    },
  }
}

export const validateBeneficiaryWithAmountDeductionApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.validateBeneficiary,
    method: 'POST',
    config: config,
    body: returnValidateBeneficiaryData(body, RootStore.agent.agentInfo),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
